import React from 'react';
import { useTranslation } from 'react-i18next';

import '../styles/componentsStyles/TopLeaders.css';
import { Button } from '../../shared/components/button/Button';
import SingleLeader from './SingleLeader';

function TopLeaders({
  dataToMap,
  challengeType,
  leadersNumber,
  buttonText,
  isActive,
  handleButtonClick,
}) {
  const { t } = useTranslation();
  return (
    <div className="leaders">
      <ul className="leaders-heads" aria-label={t('CH028')}>
        {dataToMap.map((leader, index) => (
          <SingleLeader
            key={index}
            leader={leader}
            index={index}
            leadersNumber={leadersNumber}
            challengeType={challengeType}
          />
        ))}
      </ul>
      {isActive && (
        <Button className="feature-btn topLeaders" onClick={handleButtonClick}>
          {buttonText}
        </Button>
      )}
    </div>
  );
}

export default TopLeaders;
